<template>
  <el-aside width="200px">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      style="height: calc(100vh - 60px);"
      router
    >
      <!-- <el-menu-item index="/statistics">
        <el-icon><DataAnalysis /></el-icon>
        <template #title>工作台</template>
      </el-menu-item> -->
      <!-- <el-menu-item index="/store">
        <el-icon><Shop /></el-icon>
        <template #title>店铺设置</template>
      </el-menu-item> -->
      <el-menu-item index="/setting">
        <el-icon><Setting /></el-icon>
        <template #title>仓库设置</template>
      </el-menu-item>
      <el-menu-item index="/updata">
        <el-icon><MessageBox /></el-icon>
        <template #title>更新数据</template>
      </el-menu-item>
      <el-menu-item index="/users">
        <el-icon><User /></el-icon>
        <template #title>账号列表</template>
      </el-menu-item>
      <el-menu-item index="/logs">
        <el-icon><Notebook /></el-icon>
        <template #title>日志</template>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import {useRoute} from 'vue-router'
const route = useRoute()
const path = route.path
const activeIndex = ref(path)

</script>
